import React from 'react'
import config from 'SRC/config/config.json'

export const PasswordTip = () =>
  <div className='info-polje info-login'>
    <p className='heading'>{config.loginForm.labels.password}</p>
    <p>{config.loginForm.toolTips.password}</p>
  </div>
